/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ApproveDocumentRequestRequest,
  ApproveDocumentResponse,
  DocumentUpload,
  DocumentUploadCreateRequest,
  DocumentUploadDetail,
  DocumentUploadsDocumentsListParams,
  DocumentUploadsListParams,
  DocumentUploadsOnboardingPortfoliosListParams,
  FlagDocumentRequestRequest,
  FlagDocumentResponse,
  OnboardingPortfoliosError,
  OnboardingSelectorOption,
  PaginatedDocumentUploadList,
  PaginatedProcessedDocumentList,
  ProcessedDocument,
  ReclassifyDocumentRequestRequest,
  ReclassifyDocumentResponse,
  RejectDocumentRequestRequest,
  RejectDocumentResponse,
  ResolveFlagResponse,
  SplitReviewApproveRequestRequest,
  SplitReviewApproveResponse,
  SplitReviewResponse
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type documentUploadsListResponse200 = {
  data: PaginatedDocumentUploadList
  status: 200
}

export type documentUploadsListResponseSuccess = (documentUploadsListResponse200) & {
  headers: Headers;
};
;

export type documentUploadsListResponse = (documentUploadsListResponseSuccess)

export const getDocumentUploadsListUrl = (params?: DocumentUploadsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/document-uploads/?${stringifiedParams}` : `/api/v1/document-uploads/`
}

/**
 * API endpoint for document uploads.
 *
 * POST /api/v1/document-uploads/
 *     Upload a PDF file and trigger processing workflow.
 *
 * GET /api/v1/document-uploads/
 *     List user's uploads with status and document counts.
 *
 * GET /api/v1/document-uploads/{id}/
 *     Retrieve upload details including processed documents summary.
 */
export const documentUploadsList = async (params?: DocumentUploadsListParams, options?: RequestInit): Promise<documentUploadsListResponse> => {

  return customFetch<documentUploadsListResponse>(getDocumentUploadsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type documentUploadsCreateResponse201 = {
  data: DocumentUpload
  status: 201
}

export type documentUploadsCreateResponseSuccess = (documentUploadsCreateResponse201) & {
  headers: Headers;
};
;

export type documentUploadsCreateResponse = (documentUploadsCreateResponseSuccess)

export const getDocumentUploadsCreateUrl = () => {




  return `/api/v1/document-uploads/`
}

/**
 * Create a new document upload and trigger processing.
 *
 * The default schema would type the 201 body as the request serializer
 * (``DocumentUploadCreate``); declare the read serializer so the SDK gets
 * the full ``DocumentUpload`` this actually returns.
 */
export const documentUploadsCreate = async (documentUploadCreateRequest: DocumentUploadCreateRequest, options?: RequestInit): Promise<documentUploadsCreateResponse> => {

  return customFetch<documentUploadsCreateResponse>(getDocumentUploadsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(documentUploadCreateRequest)
  }
);}


export type documentUploadsDocumentsListResponse200 = {
  data: PaginatedProcessedDocumentList
  status: 200
}

export type documentUploadsDocumentsListResponseSuccess = (documentUploadsDocumentsListResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsListResponse = (documentUploadsDocumentsListResponseSuccess)

export const getDocumentUploadsDocumentsListUrl = (documentUploadPk: string,
    params?: DocumentUploadsDocumentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/document-uploads/${documentUploadPk}/documents/?${stringifiedParams}` : `/api/v1/document-uploads/${documentUploadPk}/documents/`
}

/**
 * API endpoint for processed documents (nested under upload).
 *
 * GET /api/v1/document-uploads/{upload_pk}/documents/
 *     List processed documents for an upload.
 *
 * GET /api/v1/document-uploads/{upload_pk}/documents/{id}/
 *     Retrieve processed document detail with extracted data and FK suggestions.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/approve/
 *     Approve document and create entity from request body.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/reject/
 *     Reject document without creating entity.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/reclassify/
 *     Change classification and trigger re-extraction.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/flag/
 *     Flag document for legacy processing.
 */
export const documentUploadsDocumentsList = async (documentUploadPk: string,
    params?: DocumentUploadsDocumentsListParams, options?: RequestInit): Promise<documentUploadsDocumentsListResponse> => {

  return customFetch<documentUploadsDocumentsListResponse>(getDocumentUploadsDocumentsListUrl(documentUploadPk,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type documentUploadsDocumentsRetrieveResponse200 = {
  data: ProcessedDocument
  status: 200
}

export type documentUploadsDocumentsRetrieveResponseSuccess = (documentUploadsDocumentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsRetrieveResponse = (documentUploadsDocumentsRetrieveResponseSuccess)

export const getDocumentUploadsDocumentsRetrieveUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/`
}

/**
 * API endpoint for processed documents (nested under upload).
 *
 * GET /api/v1/document-uploads/{upload_pk}/documents/
 *     List processed documents for an upload.
 *
 * GET /api/v1/document-uploads/{upload_pk}/documents/{id}/
 *     Retrieve processed document detail with extracted data and FK suggestions.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/approve/
 *     Approve document and create entity from request body.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/reject/
 *     Reject document without creating entity.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/reclassify/
 *     Change classification and trigger re-extraction.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/flag/
 *     Flag document for legacy processing.
 */
export const documentUploadsDocumentsRetrieve = async (documentUploadPk: string,
    id: string, options?: RequestInit): Promise<documentUploadsDocumentsRetrieveResponse> => {

  return customFetch<documentUploadsDocumentsRetrieveResponse>(getDocumentUploadsDocumentsRetrieveUrl(documentUploadPk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type documentUploadsDocumentsApproveCreateResponse200 = {
  data: ApproveDocumentResponse
  status: 200
}

export type documentUploadsDocumentsApproveCreateResponseSuccess = (documentUploadsDocumentsApproveCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsApproveCreateResponse = (documentUploadsDocumentsApproveCreateResponseSuccess)

export const getDocumentUploadsDocumentsApproveCreateUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/approve/`
}

/**
 * Approve a document and create the corresponding entity.
 *
 * The request body should contain the final entity data (mapped by frontend),
 * not raw extracted_data.
 *
 * Delegates to the request-free approval service so the HTTP path and the
 * auto-approval pipeline share identical, atomic entity-creation logic.
 */
export const documentUploadsDocumentsApproveCreate = async (documentUploadPk: string,
    id: string,
    approveDocumentRequestRequest?: ApproveDocumentRequestRequest, options?: RequestInit): Promise<documentUploadsDocumentsApproveCreateResponse> => {

  return customFetch<documentUploadsDocumentsApproveCreateResponse>(getDocumentUploadsDocumentsApproveCreateUrl(documentUploadPk,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveDocumentRequestRequest)
  }
);}


export type documentUploadsDocumentsFlagCreateResponse200 = {
  data: FlagDocumentResponse
  status: 200
}

export type documentUploadsDocumentsFlagCreateResponseSuccess = (documentUploadsDocumentsFlagCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsFlagCreateResponse = (documentUploadsDocumentsFlagCreateResponseSuccess)

export const getDocumentUploadsDocumentsFlagCreateUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/flag/`
}

/**
 * Flag document for legacy processing.
 *
 * Request body must include 'reason' field.
 */
export const documentUploadsDocumentsFlagCreate = async (documentUploadPk: string,
    id: string,
    flagDocumentRequestRequest: FlagDocumentRequestRequest, options?: RequestInit): Promise<documentUploadsDocumentsFlagCreateResponse> => {

  return customFetch<documentUploadsDocumentsFlagCreateResponse>(getDocumentUploadsDocumentsFlagCreateUrl(documentUploadPk,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(flagDocumentRequestRequest)
  }
);}


export type documentUploadsDocumentsReclassifyCreateResponse200 = {
  data: ReclassifyDocumentResponse
  status: 200
}

export type documentUploadsDocumentsReclassifyCreateResponseSuccess = (documentUploadsDocumentsReclassifyCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsReclassifyCreateResponse = (documentUploadsDocumentsReclassifyCreateResponseSuccess)

export const getDocumentUploadsDocumentsReclassifyCreateUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/reclassify/`
}

/**
 * Change classification and trigger re-extraction.
 *
 * Request body must include 'classification' field with valid classification.
 */
export const documentUploadsDocumentsReclassifyCreate = async (documentUploadPk: string,
    id: string,
    reclassifyDocumentRequestRequest: ReclassifyDocumentRequestRequest, options?: RequestInit): Promise<documentUploadsDocumentsReclassifyCreateResponse> => {

  return customFetch<documentUploadsDocumentsReclassifyCreateResponse>(getDocumentUploadsDocumentsReclassifyCreateUrl(documentUploadPk,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reclassifyDocumentRequestRequest)
  }
);}


export type documentUploadsDocumentsRejectCreateResponse200 = {
  data: RejectDocumentResponse
  status: 200
}

export type documentUploadsDocumentsRejectCreateResponseSuccess = (documentUploadsDocumentsRejectCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsRejectCreateResponse = (documentUploadsDocumentsRejectCreateResponseSuccess)

export const getDocumentUploadsDocumentsRejectCreateUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/reject/`
}

/**
 * Reject a document without creating an entity.
 *
 * Request body can optionally include a 'reason' field.
 */
export const documentUploadsDocumentsRejectCreate = async (documentUploadPk: string,
    id: string,
    rejectDocumentRequestRequest?: RejectDocumentRequestRequest, options?: RequestInit): Promise<documentUploadsDocumentsRejectCreateResponse> => {

  return customFetch<documentUploadsDocumentsRejectCreateResponse>(getDocumentUploadsDocumentsRejectCreateUrl(documentUploadPk,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rejectDocumentRequestRequest)
  }
);}


export type documentUploadsDocumentsResolveFlagCreateResponse200 = {
  data: ResolveFlagResponse
  status: 200
}

export type documentUploadsDocumentsResolveFlagCreateResponseSuccess = (documentUploadsDocumentsResolveFlagCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsResolveFlagCreateResponse = (documentUploadsDocumentsResolveFlagCreateResponseSuccess)

export const getDocumentUploadsDocumentsResolveFlagCreateUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/resolve-flag/`
}

/**
 * Resolve a flagged document as manually handled.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/resolve-flag/
 *     Marks a flagged document as manually resolved.
 *
 * Request body can optionally include 'feedback'.
 */
export const documentUploadsDocumentsResolveFlagCreate = async (documentUploadPk: string,
    id: string, options?: RequestInit): Promise<documentUploadsDocumentsResolveFlagCreateResponse> => {

  return customFetch<documentUploadsDocumentsResolveFlagCreateResponse>(getDocumentUploadsDocumentsResolveFlagCreateUrl(documentUploadPk,id),
  {
    ...options,
    method: 'POST'


  }
);}


export type documentUploadsDocumentsRetryExtractionCreateResponse200 = {
  data: ReclassifyDocumentResponse
  status: 200
}

export type documentUploadsDocumentsRetryExtractionCreateResponseSuccess = (documentUploadsDocumentsRetryExtractionCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsDocumentsRetryExtractionCreateResponse = (documentUploadsDocumentsRetryExtractionCreateResponseSuccess)

export const getDocumentUploadsDocumentsRetryExtractionCreateUrl = (documentUploadPk: string,
    id: string,) => {




  return `/api/v1/document-uploads/${documentUploadPk}/documents/${id}/retry-extraction/`
}

/**
 * Retry extraction for a document with the same classification.
 *
 * POST /api/v1/document-uploads/{upload_pk}/documents/{id}/retry-extraction/
 *     Resets extraction status and triggers a new extraction task.
 */
export const documentUploadsDocumentsRetryExtractionCreate = async (documentUploadPk: string,
    id: string, options?: RequestInit): Promise<documentUploadsDocumentsRetryExtractionCreateResponse> => {

  return customFetch<documentUploadsDocumentsRetryExtractionCreateResponse>(getDocumentUploadsDocumentsRetryExtractionCreateUrl(documentUploadPk,id),
  {
    ...options,
    method: 'POST'


  }
);}


export type documentUploadsRetrieveResponse200 = {
  data: DocumentUploadDetail
  status: 200
}

export type documentUploadsRetrieveResponseSuccess = (documentUploadsRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentUploadsRetrieveResponse = (documentUploadsRetrieveResponseSuccess)

export const getDocumentUploadsRetrieveUrl = (id: string,) => {




  return `/api/v1/document-uploads/${id}/`
}

/**
 * API endpoint for document uploads.
 *
 * POST /api/v1/document-uploads/
 *     Upload a PDF file and trigger processing workflow.
 *
 * GET /api/v1/document-uploads/
 *     List user's uploads with status and document counts.
 *
 * GET /api/v1/document-uploads/{id}/
 *     Retrieve upload details including processed documents summary.
 */
export const documentUploadsRetrieve = async (id: string, options?: RequestInit): Promise<documentUploadsRetrieveResponse> => {

  return customFetch<documentUploadsRetrieveResponse>(getDocumentUploadsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type documentUploadsRetryCreateResponse200 = {
  data: DocumentUpload
  status: 200
}

export type documentUploadsRetryCreateResponseSuccess = (documentUploadsRetryCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsRetryCreateResponse = (documentUploadsRetryCreateResponseSuccess)

export const getDocumentUploadsRetryCreateUrl = (id: string,) => {




  return `/api/v1/document-uploads/${id}/retry/`
}

/**
 * Retry processing for a failed upload.
 *
 * POST /api/v1/document-uploads/{id}/retry/
 *     Resets the upload status and triggers a new processing task.
 */
export const documentUploadsRetryCreate = async (id: string, options?: RequestInit): Promise<documentUploadsRetryCreateResponse> => {

  return customFetch<documentUploadsRetryCreateResponse>(getDocumentUploadsRetryCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type documentUploadsSplitReviewRetrieveResponse200 = {
  data: SplitReviewResponse
  status: 200
}

export type documentUploadsSplitReviewRetrieveResponseSuccess = (documentUploadsSplitReviewRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentUploadsSplitReviewRetrieveResponse = (documentUploadsSplitReviewRetrieveResponseSuccess)

export const getDocumentUploadsSplitReviewRetrieveUrl = (id: string,) => {




  return `/api/v1/document-uploads/${id}/split-review/`
}

/**
 * Return the proposed split boundaries and the original PDF url for an
 * upload awaiting split review.
 *
 * GET /api/v1/document-uploads/{id}/split-review/
 *     Returns 409 if the upload is not in AWAITING_SPLIT_REVIEW.
 */
export const documentUploadsSplitReviewRetrieve = async (id: string, options?: RequestInit): Promise<documentUploadsSplitReviewRetrieveResponse> => {

  return customFetch<documentUploadsSplitReviewRetrieveResponse>(getDocumentUploadsSplitReviewRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type documentUploadsSplitReviewApproveCreateResponse200 = {
  data: SplitReviewApproveResponse
  status: 200
}

export type documentUploadsSplitReviewApproveCreateResponseSuccess = (documentUploadsSplitReviewApproveCreateResponse200) & {
  headers: Headers;
};
;

export type documentUploadsSplitReviewApproveCreateResponse = (documentUploadsSplitReviewApproveCreateResponseSuccess)

export const getDocumentUploadsSplitReviewApproveCreateUrl = (id: string,) => {




  return `/api/v1/document-uploads/${id}/split-review/approve/`
}

/**
 * Approve the operator's final split boundaries.
 *
 * POST /api/v1/document-uploads/{id}/split-review/approve/
 *     Validates the boundary array, materializes the ProcessedDocuments
 *     in one transaction, flips status to CLASSIFYING, and enqueues
 *     ``resume_after_split_review`` on commit. Idempotent on re-POST.
 */
export const documentUploadsSplitReviewApproveCreate = async (id: string,
    splitReviewApproveRequestRequest: SplitReviewApproveRequestRequest, options?: RequestInit): Promise<documentUploadsSplitReviewApproveCreateResponse> => {

  return customFetch<documentUploadsSplitReviewApproveCreateResponse>(getDocumentUploadsSplitReviewApproveCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(splitReviewApproveRequestRequest)
  }
);}


export type documentUploadsOnboardingConsultantGroupsListResponse200 = {
  data: OnboardingSelectorOption[]
  status: 200
}

export type documentUploadsOnboardingConsultantGroupsListResponseSuccess = (documentUploadsOnboardingConsultantGroupsListResponse200) & {
  headers: Headers;
};
;

export type documentUploadsOnboardingConsultantGroupsListResponse = (documentUploadsOnboardingConsultantGroupsListResponseSuccess)

export const getDocumentUploadsOnboardingConsultantGroupsListUrl = () => {




  return `/api/v1/document-uploads/onboarding/consultant-groups/`
}

/**
 * Return all Consultant Groups sorted by name.
 *
 * GET /api/v1/document-uploads/onboarding/consultant-groups/
 *     Returns [{ "id", "name" }] for every ConsultantGroup in the system.
 */
export const documentUploadsOnboardingConsultantGroupsList = async ( options?: RequestInit): Promise<documentUploadsOnboardingConsultantGroupsListResponse> => {

  return customFetch<documentUploadsOnboardingConsultantGroupsListResponse>(getDocumentUploadsOnboardingConsultantGroupsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type documentUploadsOnboardingPortfoliosListResponse200 = {
  data: OnboardingSelectorOption[]
  status: 200
}

export type documentUploadsOnboardingPortfoliosListResponse422 = {
  data: OnboardingPortfoliosError
  status: 422
}

export type documentUploadsOnboardingPortfoliosListResponseSuccess = (documentUploadsOnboardingPortfoliosListResponse200) & {
  headers: Headers;
};
export type documentUploadsOnboardingPortfoliosListResponseError = (documentUploadsOnboardingPortfoliosListResponse422) & {
  headers: Headers;
};

export type documentUploadsOnboardingPortfoliosListResponse = (documentUploadsOnboardingPortfoliosListResponseSuccess | documentUploadsOnboardingPortfoliosListResponseError)

export const getDocumentUploadsOnboardingPortfoliosListUrl = (params: DocumentUploadsOnboardingPortfoliosListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/document-uploads/onboarding/portfolios/?${stringifiedParams}` : `/api/v1/document-uploads/onboarding/portfolios/`
}

/**
 * Return portfolios that contain at least one property belonging to the
 * given Consultant Group.
 *
 * GET /api/v1/document-uploads/onboarding/portfolios/?consultant_group=<uuid>
 *     Returns [{ "id", "name" }] (distinct, sorted by name).
 *     Returns 422 if the consultant_group query param is missing.
 */
export const documentUploadsOnboardingPortfoliosList = async (params: DocumentUploadsOnboardingPortfoliosListParams, options?: RequestInit): Promise<documentUploadsOnboardingPortfoliosListResponse> => {

  return customFetch<documentUploadsOnboardingPortfoliosListResponse>(getDocumentUploadsOnboardingPortfoliosListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


